/* VialArt — Free Applicator Stand auto-gift + tiered cart progress nudge.
   - Adds 1 free applicator stand (variant 52715775820052, $0.00) when the
     merchandise subtotal reaches $99; removes it below $99 (server-cart based).
   - Renders a progress nudge in the cart drawer + cart page:
       < $49  : "Add $X for free U.S. shipping"
       $49-99 : "Free U.S. shipping! Add $Y for a free applicator stand"
       >= $99 : "Unlocked free U.S. shipping + a free applicator stand"
   Free shipping is U.S.-only (Shopify automatic discount), hence the wording.
   Thresholds use ORIGINAL (pre-discount) line prices so a future discount code
   can't silently revoke an earned gift. NOTE: USD-only store assumption ($/cents).
   NOTE: the $0 gift is enforced client-side only; a server-side reconcile is
   recommended if abuse becomes a concern. */
(function () {
  var GIFT_VARIANT = 52715775820052; // "Free Applicator Stand" / 1 unit / $0.00
  var SHIP = 4900;                   // free U.S. shipping threshold (cents)
  var GIFT = 9900;                   // free applicator threshold (cents)
  var GIFT_NOTE = 'Free 3 mL applicator stand — $99+ bonus';
  var working = false;
  var lastSub = null;                // last known non-gift subtotal (cents)
  var addAttempts = 0;               // bounded retry guard for failed gift writes

  function lineVal(it) { return (it.original_line_price != null ? it.original_line_price : it.final_line_price) || 0; }
  function nonGiftSubtotal(cart) {
    var s = 0;
    (cart.items || []).forEach(function (it) { if (it.variant_id !== GIFT_VARIANT) s += lineVal(it); });
    return s;
  }
  function nonGiftCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.variant_id !== GIFT_VARIANT) n += it.quantity; });
    return n;
  }
  function giftLines(cart) {
    return (cart.items || []).filter(function (it) { return it.variant_id === GIFT_VARIANT; });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _gift: GIFT_NOTE } }] })
    }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r; });
  }
  function setGiftQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r; });
  }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function aria(s) { return '<span aria-hidden="true">' + s + '</span>'; }

  function toast(msg) {
    try {
      var t = document.createElement('div');
      t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;'
        + 'background:#1b1030;color:#fff;border:1px solid #7c4dff;border-radius:12px;padding:12px 18px;'
        + 'font:600 14px/1.35 system-ui,-apple-system,sans-serif;box-shadow:0 10px 34px rgba(0,0,0,.5);'
        + 'max-width:90vw;text-align:center;opacity:0;transition:opacity .25s,transform .25s';
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.body.appendChild(t);
      if (reduce) { t.style.opacity = '1'; }
      else { requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(-6px)'; }); }
      setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 300); }, 3400);
    } catch (e) {}
  }

  // ---- progress nudge ----
  function ensureNudgeCss() {
    if (document.getElementById('va-gn-css')) return;
    var st = document.createElement('style');
    st.id = 'va-gn-css';
    st.textContent =
      '.va-gn{margin:0 0 14px;padding:11px 14px;border-radius:12px;background:linear-gradient(135deg,#1b1030,#2a1550);'
      + 'border:1px solid rgba(124,77,255,.45);color:#fff;font:600 13px/1.35 system-ui,-apple-system,sans-serif;}'
      + '.va-gn__msg{margin:0 0 8px;text-align:center;}'
      + '.va-gn__msg b{color:#d8c6ff;font-weight:800;}'
      + '.va-gn__track{height:7px;border-radius:6px;background:rgba(255,255,255,.14);overflow:hidden;}'
      + '.va-gn__fill{height:100%;border-radius:6px;background:linear-gradient(90deg,#7c4dff,#b388ff);transition:width .4s ease;}'
      + '.va-gn--done{background:linear-gradient(135deg,#16321f,#1f5135);border-color:rgba(74,222,128,.5);}'
      + '.va-gn--done .va-gn__fill{background:linear-gradient(90deg,#34d399,#a7f3d0);}'
      + '@media (prefers-reduced-motion: reduce){.va-gn__fill{transition:none;}}';
    document.head.appendChild(st);
  }
  function nudgeHTML(sub) {
    var msg, done = false, pct;
    if (sub >= GIFT) { msg = aria('🎁') + ' You unlocked free U.S. shipping <b>+ a free 3 mL applicator stand!</b>'; done = true; pct = 100; }
    else if (sub >= SHIP) { msg = aria('✓') + ' Free U.S. shipping! Add <b>' + money(GIFT - sub) + '</b> for a free 3 mL applicator stand ' + aria('🎁'); pct = Math.min(99, Math.round(sub / GIFT * 100)); }
    else { msg = 'Add <b>' + money(SHIP - sub) + '</b> for free U.S. shipping ' + aria('🚚'); pct = Math.min(99, Math.round(sub / GIFT * 100)); }
    return { msg: msg, pct: pct, done: done };
  }
  function paintNudge(el, sub) {
    var d = nudgeHTML(sub);
    var sig = d.pct + '|' + d.done + '|' + d.msg;
    if (el.dataset.sig === sig) return; // no-op when unchanged -> prevents observer self-loop + re-announce
    el.dataset.sig = sig;
    el.className = 'va-gn' + (d.done ? ' va-gn--done' : '');
    el.innerHTML = '<div class="va-gn__msg">' + d.msg + '</div>'
      + '<div class="va-gn__track"><div class="va-gn__fill" style="width:' + d.pct + '%"></div></div>';
  }
  function placeNudge(container, id, sub) {
    if (!container) return;
    var el = document.getElementById(id);
    if (!el || !container.contains(el)) {
      if (el) el.remove();
      el = document.createElement('div');
      el.id = id;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      container.insertBefore(el, container.firstChild);
    }
    paintNudge(el, sub);
  }
  function clearNudges() {
    ['va-gn-drawer', 'va-gn-page'].forEach(function (id) { var e = document.getElementById(id); if (e) e.remove(); });
  }
  function renderNudge(sub) {
    if (sub == null) return;
    if (sub <= 0) { clearNudges(); return; } // empty cart -> no nudge
    ensureNudgeCss();
    placeNudge(document.querySelector('.cart-drawer__content'), 'va-gn-drawer', sub);
    if (location.pathname.indexOf('/cart') === 0 && document.querySelector('.cart-page__items')) {
      placeNudge(document.querySelector('.cart-page'), 'va-gn-page', sub);
    }
  }

  function refreshUI(changed) {
    if (!changed) return;
    if (location.pathname.indexOf('/cart') === 0) {
      // Guard against a pathological reload loop: at most one reload per 5s.
      try {
        var last = +(sessionStorage.getItem('vaGiftReloadTs') || 0);
        var now = (window.performance && performance.now) ? performance.timeOrigin + performance.now() : last + 6000;
        if (now - last > 5000) { sessionStorage.setItem('vaGiftReloadTs', String(now)); location.reload(); return; }
      } catch (e) { location.reload(); return; }
      renderNudge(lastSub);
      return;
    }
    ['cart:refresh', 'cart:build', 'cart-updated', 'cart:change'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
    try { if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart(); } catch (e) {}
  }

  function sync() {
    if (working) return Promise.resolve();
    return getCart().then(function (cart) {
      var sub = nonGiftSubtotal(cart);
      lastSub = (nonGiftCount(cart) > 0) ? sub : 0;
      var lines = giftLines(cart);
      var line = lines[0];
      // collapse any accidental duplicate gift lines to one
      if (lines.length > 1) {
        working = true;
        return setGiftQty(lines[1].key, 0).then(function () { working = false; schedule(); })
          .catch(function () { working = false; });
      }
      if (sub >= GIFT && !line) {
        working = true;
        return addGift().then(function () {
          working = false; addAttempts = 0;
          toast('🎁 You unlocked a FREE 3 mL applicator stand — added to your cart!');
          refreshUI(true);
        }).catch(function () {
          working = false;
          if (addAttempts++ < 2) setTimeout(schedule, 1500); // bounded retry on transient failure
        });
      }
      if (sub >= GIFT && line && line.quantity !== 1) {
        working = true;
        return setGiftQty(line.key, 1).then(function () { working = false; refreshUI(true); })
          .catch(function () { working = false; });
      }
      if (sub < GIFT && line) {
        working = true;
        return setGiftQty(line.key, 0).then(function () { working = false; refreshUI(true); })
          .catch(function () { working = false; });
      }
      renderNudge(lastSub);
    }).catch(function () { working = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  // Re-evaluate + re-paint after any cart mutation the theme performs (debounced).
  var deb;
  function schedule() { clearTimeout(deb); deb = setTimeout(sync, 350); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : String((input && (input.url || input.href)) || ''); } catch (e) {}
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url) && !working) { p.then(schedule, function () {}); }
      return p;
    };
  }

  // Horizon re-renders the cart via section morphing, which can wipe the nudge.
  // Re-inject from the cached subtotal whenever the cart drawer / cart page mutates.
  var robs;
  function reobserve() { clearTimeout(robs); robs = setTimeout(function () { renderNudge(lastSub); }, 120); }
  try {
    var mo = new MutationObserver(reobserve);
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    if (location.pathname.indexOf('/cart') === 0) {
      var main = document.getElementById('MainContent');
      if (main) mo.observe(main, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
